<template>
  <div :class="cn('pb-10 pt-3.5 lg:pb-18 lg:pt-10', props.class)">
    <div class="container mb-7.5 lg:mb-12 flex items-center">
      <h4
        v-if="title"
        class="text-xl capitalize text-primary lg:text-3xl font-medium font-manrope"
        v-html="title"
      />
      <div v-if="!hideArrows" class="ml-auto shrink-0 space-x-5 max-lg:hidden">
        <button
          ref="prevEl"
          :aria-label="$t('previousSlide')"
          class="inline-flex items-center justify-center rounded-full border border-black p-2.5 transition-all"
        >
          <UiIcon name="arrow_left" class="size-6 text-primary" />
        </button>
        <button
          ref="nextEl"
          :aria-label="$t('nextSlide')"
          class="inline-flex items-center justify-center rounded-full border border-black p-2.5 transition-all"
        >
          <UiIcon name="arrow_right" class="size-6 text-primary" />
        </button>
      </div>
    </div>
    <UiScrollableSlider
      :slides-count="1.7"
      :items-list="products"
      class="container px-0 lg:!hidden"
      :gap-x="15"
    >
      <template #card="{ item, idx }">
        <CommonProductCardPlp
          :product="item"
          :product-index="idx"
          :plp-type="plpTypes.default"
          :statistic-item-list-name="statisticItemListName"
        />
      </template>
    </UiScrollableSlider>
    <div class="container max-lg:hidden">
      <Swiper
        :slides-per-view="1.75"
        :modules="modules"
        :space-between="16"
        :navigation="navigation"
        class="w-full"
        :breakpoints="{
          [screens.lg]: {
            spaceBetween: 16,
            slidesPerView: 4,
          },
        }"
        @swiper="initSwiper"
        @resize="onUpdateSwiper"
      >
        <SwiperSlide
          v-for="(item, idx) in products?.slice(0, 15)"
          :key="item.id"
          class="max-md:px-2.5"
        >
          <CommonProductCardPlp
            :product="item"
            :product-index="idx"
            :plp-type="plpTypes.default"
            :statistic-item-list-name="statisticItemListName"
          />
        </SwiperSlide>
      </Swiper>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation } from "swiper";
import { NavigationOptions } from "swiper/types";
import { debounce } from "lodash-es";
import { HTMLAttributes } from "vue";
import { CatalogData } from "ecom-types";
import { screens } from "@/configs/breakpointsConfig.json";
import { plpTypes } from "~/configs";

const props = defineProps<{
  title?: string;
  statisticItemListName?: string;
  products: CatalogData[];
  class?: HTMLAttributes["class"];
}>();

const isMounted = useMounted();
const { viewItemListEvent } = useEvents();

const hideArrows = ref(true);

const prevEl = ref<HTMLElement | null>(null);
const nextEl = ref<HTMLElement | null>(null);

const debounceSwiper = debounce((params) => {
  hideArrows.value = params?.params?.slidesPerView >= props.products.length;
}, 200);

function initSwiper(params: any) {
  debounceSwiper(params);
}
function onUpdateSwiper(params: any) {
  debounceSwiper(params);
}

const navigation = reactive({
  prevEl,
  nextEl,
  disabledClass: "opacity-20 cursor-not-allowed",
}) as NavigationOptions;

const modules = [Navigation];

watchEffect(() => {
  if (isMounted.value && props.products) {
    viewItemListEvent(props.products, {
      item_list_name: props.statisticItemListName,
    });
  }
});
</script>
